import React from 'react'
import { makeStyles } from '@mui/styles'

import Sidebar from './sidebar'

const ContentWrapper = ({
  children,
  imageUrl,
  className = '',
  hideStepper = false,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.content}>
      <Sidebar imageUrl={imageUrl} hideStepper={hideStepper} />
      <div className={`${classes.root} ${className}`}>
        {children}
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  content: {
    flex: 1,
    display: 'flex',
    width: '100%',
    flexDirection: 'column-reverse',
    height: 'auto',
    '@media (min-width: 800px)': {
      height: '100%',
      flexDirection: 'row',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
}))

export default ContentWrapper
